import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { NavLink } from "react-router-dom";
import { FilePenLine, LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { activeGenerationStatuses, useLatestContentGeneration } from "@/hooks/useContentGeneration";


export function ContentGenerationStatus() {
  const { data: job } = useLatestContentGeneration();
  const queryClient = useQueryClient();
  const previousStatus = useRef(null);

  useEffect(() => {
    if (!job) return;
    if (previousStatus.current && previousStatus.current !== job.status) {
      if (job.status === "completed") {
        queryClient.invalidateQueries({ queryKey: ["content"] });
        queryClient.invalidateQueries({ queryKey: ["dashboard"] });
        toast.success(`Article ready: ${job.keyword}`);
      }
      if (job.status === "failed") toast.error(job.error || "Article generation failed");
    }
    previousStatus.current = job.status;
  }, [job, queryClient]);

  if (!job || !activeGenerationStatuses.includes(job.status)) return null;
  return <NavLink to="/app/content" className="generation-status" data-testid="background-generation-status">
    <LoaderCircle className="spin" size={14}/>
    <span><b>Generating article</b><small>{job.keyword}</small></span>
    <FilePenLine size={14}/>
  </NavLink>;
}